import useOperationLoadingState from '../hooks/use-operation-loading-state'

export default function WhenLoading (props) {
  const [isLoading] = useOperationLoadingState()

  return isLoading ? props.children : null
}
